"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _A11yContext = _interopRequireDefault(require("../context/A11yContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var ARROW_DOWN = 'ArrowDown';
var ARROW_LEFT = 'ArrowLeft';
var ARROW_RIGHT = 'ArrowRight';
var ARROW_UP = 'ArrowUp';
var END = 'End';
var HOME = 'Home';
var KEYS = [ARROW_DOWN, ARROW_LEFT, ARROW_RIGHT, ARROW_UP, END, HOME];
var KEY_EVENT_BYPASS_CLASSES = ['textarea'];
/**
 * Adds given element to an array of focusable elements
 * and provides functions that handle various a11y states
 * such as focus management and keyboard navigation.
 * @param {Object} element - focusable element to register
 * @return {Object} event handler functions
 */

function useA11y(element) {
  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      forceUpdate = _useState2[1];

  var context = (0, _react.useContext)(_A11yContext.default);

  if (context === undefined) {
    throw new Error('useA11y must be used within a A11yProvider');
  }

  var registerElement = context.registerElement,
      unregisterElement = context.unregisterElement,
      focusableElements = context.focusableElements;
  var index = focusableElements.findIndex(function (focusableElement) {
    return focusableElement === element;
  });
  var length = focusableElements.length;
  (0, _react.useEffect)(function () {
    if (!element) {
      // Force update children after initial render
      // to make sure a ref is attached to a DOM element.
      forceUpdate(true);
    }

    registerElement(element);
    return function () {
      return unregisterElement(element);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [element]);

  var handleKeyDown = function handleKeyDown(event) {
    if (!KEYS.includes(event.key) || _toConsumableArray(event.target.classList).some(function (curClass) {
      return KEY_EVENT_BYPASS_CLASSES.includes(curClass);
    })) {
      return;
    }

    switch (event.key) {
      case ARROW_DOWN:
        {
          event.preventDefault();
          var nextIndex = (index + 1) % length;
          focusableElements[nextIndex].focus();
          break;
        }

      case ARROW_UP:
        {
          event.preventDefault();
          var prevIndex = (index + length - 1) % length;
          focusableElements[prevIndex].focus();
          break;
        }

      case HOME:
        event.preventDefault();
        focusableElements[0].focus();
        break;

      case END:
        event.preventDefault();
        focusableElements[length - 1].focus();
        break;

      default:
        break;
    }
  };

  return {
    onKeyDown: handleKeyDown
  };
}

var _default = useA11y;
exports.default = _default;